/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  IonContent,
  IonButton,
  IonIcon,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonPage,
} from '@ionic/react';
import {
  Typography, Card, Stack, Box,
} from '@mui/material';
import PropTypes from 'prop-types';
import useFetch from 'use-http';
import { arrowForwardCircleOutline } from 'ionicons/icons';
import './SmartGoals.css';
import appColors from 'common/app_colors';
import appStrings from 'common/app_strings';

const { container, text } = appColors;
const { goals: { smartGoalTemplate: STRINGS } } = appStrings;

const SmartGoalTemplate = ({ onComplete, onBack, goalData }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templates, setTemplates] = useState([]);
  const { post: doPost } = useFetch();
  const [loading, setLoading] = useState(false);

  const handleTemplateClick = (template) => {
    onComplete({ selected_template: template.content });
  };

  const handleGetTemplates = async () => {
    setLoading(true);
    const subtypeIds = goalData?.subtypes?.map((subtype) => subtype.subtype_id);

    const response = await doPost('/goals/exemplars', { subtype_ids: subtypeIds, type: goalData?.type });
    setTemplates(response);
    setLoading(false);
  };

  useEffect(() => {
    void (async () => {
    await handleGetTemplates();
  })();
  }, [goalData?.subtypes]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar className="back-button-toolbar back-button-toolbar-blue" mode="ios" style={{ '--background: ': container.darkNavy }}>
          <IonButtons slot="start">
            <IonBackButton
              text=""
              className="back-button-custom"
              icon="/assets/back-arrow.svg"
              style={{
                '--icon-font-size': '1.25rem',
                '--icon-padding-start': '8px',
                '--icon-padding-end': '12px',
                '--icon-padding-top': '4px',
                '--icon-margin-end': '6px',
                color: '#fff',
              }}
              mode="ios"
              defaultHref="/"
              onClick={onBack}
            />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent
        style={{
          '--background': container.darkNavy,
          '--padding-start': '24px',
          '--padding-end': '24px',
        }}
        fullscreen
      >
        <Stack
          sx={{
            display: 'flex',
            height: '100%',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <Typography
              variant="h6"
              color={text.whiteText}
              sx={{ mb: 3, mt: 2, textAlign: 'center' }}
            >
              {STRINGS.title}
            </Typography>

            <Stack spacing={2} mb={3} sx={{ width: '100%', boxSizing: 'border-box' }}>
              {templates?.map((template) => (
                <Card
                  key={template.id}
                  sx={{
                    p: 2,
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    borderRadius: '8px',
                    width: '100%',
                    backgroundColor: container.white,
                    flexDirection: 'row',
                    fontSize: '16px',
                  }}
                  onClick={() => handleTemplateClick(template)}
                >
                  <Typography
                    sx={{
                      flex: 1,
                      pr: 2,
                      color: text.placeholderGrey,
                      padding: '20px 0px 20px 20px',
                    }}
                  >
                    {template.content}
                  </Typography>
                  <IonIcon
                    style={{ width: '30px', height: '30px', transform: 'rotate(315deg)' }}
                    className="arrow-forward-circle-outline"
                    slot="end"
                    icon={arrowForwardCircleOutline}
                  />
                </Card>
              ))}
            </Stack>
          </Box>

          <IonButton
            style={{
              '--color': container.white,
              '--border-color': container.white,
              marginBottom: '24px',
              fontWeight: 700,
              minHeight: '57px',
            }}
            size="large"
            expand="block"
            shape="round"
            fill="outline"
            onClick={() => onComplete({ selected_template: '' })}
          >
            {STRINGS.writeMyOwn}
          </IonButton>
        </Stack>
      </IonContent>
    </IonPage>
  );
};

SmartGoalTemplate.propTypes = {
  onComplete: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default SmartGoalTemplate;
